import Affix from './affix'; // 总包导出需要

export { Affix };
export default Affix;